export default __webpack_public_path__ + "12a8fe3a3c743a49a531de46450bdb61.pdf";